export default __webpack_public_path__ + "static/media/logo.278495b5.png";